var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <p class=\"c-question-list__item__status-label\">\n        "
    + escapeExpression(((stack1 = (depth0 && depth0.answeredStatus)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n      </p>\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.is_sensitive_image), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "";
  buffer += "\n      \n    ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <div class=\"c-question-list__item__thumb\">\n        <p\n          class=\"c-question-list__item__thumb__img\"\n          style=\"background:url("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ") no-repeat center; background-size: cover\"\n        ></p>\n      </div>\n    ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <p class=\"c-question-list__item__tag\">"
    + escapeExpression(((stack1 = (depth0 && depth0.tag_list_string)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n    ";
  return buffer;
  }

function program10(depth0,data) {
  
  
  return "\n      <p class=\"c-question-list__item__filter-label\">\n        フィルター付き画像あり\n      </p>\n    ";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <li class=\"c-question-list__item__detail__user__name__child__list "
    + escapeExpression(((stack1 = (depth0 && depth0.className)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n              "
    + escapeExpression(((stack1 = (depth0 && depth0.display_birthday)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n            </li>\n          ";
  return buffer;
  }

  buffer += "<a href=\"/question/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n  <div class=\"clearfix\">\n    <p class=\"c-question-list__item__category-label c-question-list__item__category-label--"
    + escapeExpression(__default(require("../js/hbs_helpers/getCategoryUrl.js")).call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.category_id), {hash:{},data:data}))
    + "\">\n      "
    + escapeExpression(__default(require("../js/hbs_helpers/getCategoryName.js")).call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.category_id), {hash:{},data:data}))
    + "\n    </p>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.answeredStatus), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  <p class=\"c-question-list__item__desc\">\n    "
    + escapeExpression(__default(require("../js/hbs_helpers/truncate.js")).call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.content), 90, {hash:{},data:data}))
    + "\n  </p>\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.image_url), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"clearfix\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.tag_list_string), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.is_sensitive_image), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div class=\"c-question-list__item__detail clearfix\">\n    <div class=\"c-question-list__item__detail__user\">\n      <p class=\"c-question-list__item__detail__user__thumb\">\n        <img\n          class=\"c-question-list__item__detail__user__thumb__img\"\n          src=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n        >\n      </p>\n      <div class=\"c-question-list__item__detail__user__name\">\n        <p class=\"c-question-list__item__detail__user__name__perent\">\n          "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n        </p>\n\n        <ul class=\"c-question-list__item__detail__user__name__child\">\n          ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.Child), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ul>\n      </div>\n    </div>\n\n    <p class=\"c-question-list__item__detail__comment\">\n      "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Question)),stack1 == null || stack1 === false ? stack1 : stack1.answer_count)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n    </p>\n  </div>\n</a>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/question.hbs
// module id = 192
// module chunks = 0 1